export enum CHECKPOINTS_STATUS {
    NONE = 'status-none', // to be used for content blocks that do not have checkpoints
    EMPTY = 'status-empty',
    PARTIALLY_FILLED = 'status-partly-filled',
    PARTIALLY_FILLED_NOT_OK = 'status-partly-filled-not-ok',
    COMPLETELY_FILLED = 'status-completely-filled',
    COMPLETELY_FILLED_NOT_OK = 'status-completely-filled-not-ok',
}
